import {BlockComponentProps} from '../../Block'
import Container from '../../Block/Container'
import {BlockBase} from '../base'
import React from 'react'

export interface ImageBlock extends BlockBase {
  type: 'Image'
  image: null | string
  size: number
  sizeMobile: number
  borderWidth: number
  borderRadius: number
  borderColor: string
}

export default function Image(props: ImageBlock & BlockComponentProps) {
  const {image, sizeMobile, borderWidth, borderColor, id, size} = props
  if (!image) {
    return (
      <Container {...props}>
        <></>
      </Container>
    )
  }

  const className = `image-block-${id}`

  return (
    <>
      <style>
        {`
        .${className} {
          width: ${sizeMobile}%;
        }
        @media (min-width: 600px) {
          .${className} {
            width: ${size}% !important;
          }
        }
        `}
      </style>
      <Container {...props}>
        <img
          style={{
            border: `${borderWidth}px solid ${borderColor}`,
            borderRadius: `${borderWidth}%`,
          }}
          src={image}
          alt="block"
          className={className}
        />
      </Container>
    </>
  )
}
